import { ChangeDetectorRef, EventEmitter, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IxellAPIService, StatsDropdownValue, StatsGraphFilterKind } from 'src/app/tools/api.service';
import { StorageService } from 'src/app/tools/storage.service';
import { FilterProps, FilterType } from '../filters/filters.component';

@Component({
  selector: 'stats-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class StatsFilterComponent implements OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() filterProps: FilterProps;
  @Input() isRight: boolean;
  @Input() previousValue: any;
  @Input() editValues: EventEmitter<void>;

  StatsGraphFilterKind = StatsGraphFilterKind;
  FilterType = FilterType;

  dropdownOptions: StatsDropdownValue[] = [];
  isDropdownLoading: boolean = false;

  autocompleteList: string[] = [];

  enableChange: boolean = false;

  private statsGetDropdownContentsForKindSub: any;
  private statsGetAutocompleteListSub: any;
  private valueChangesSub: any;

  constructor(private apiService: IxellAPIService, private storage: StorageService, private translate: TranslateService) { }

  ngOnChanges(changes: SimpleChanges): void {
    let pValC: SimpleChange = changes['previousValue'];
    if (pValC) {
      if (this.filterProps.kind == StatsGraphFilterKind.CBGAMME
        || this.filterProps.kind == StatsGraphFilterKind.CBSERIE
        || this.filterProps.kind == StatsGraphFilterKind.CBMODEL
        || this.filterProps.kind == StatsGraphFilterKind.CBPART
        || this.filterProps.kind == StatsGraphFilterKind.CBSHOWTYPE
      )
        this.refreshContent((pValC.previousValue != pValC.currentValue) && this.enableChange);
      else if (this.filterProps.kind == StatsGraphFilterKind.CWTMODEL)
        this.getAutocompleteList(0, true, true);
    }
  }

  refreshContent(reset: boolean = false) {
    if (this.filterProps.type == FilterType.DROPDOWN) {
      let language = this.storage.get("actualLanguage");
      if (language == "" || language == null)
        language = "fr";

      let value: string = (typeof this.previousValue == 'string') ? (this.previousValue as string) : null;
      this.isDropdownLoading = true;
      this.statsGetDropdownContentsForKindSub = this.apiService.statsGetDropdownContentsForKind(this.filterProps.kind, language, value).subscribe(data => {
        this.dropdownOptions = data;

        this.isDropdownLoading = false;
        if (this.statsGetDropdownContentsForKindSub != null) this.statsGetDropdownContentsForKindSub.unsubscribe();
      })

      if (reset)
        this.formGroup.controls[StatsGraphFilterKind[this.filterProps.kind]].setValue(null);
    }
  }

  ngOnInit() {
    this.refreshContent();

    this.valueChangesSub = this.formGroup.controls[StatsGraphFilterKind[this.filterProps.kind]].valueChanges.subscribe(() => {
      this.editValues.emit();
    });
  }

  ngAfterViewInit() {
    this.enableChange = true;
  }

  ngOnDestroy() {
    if (this.statsGetDropdownContentsForKindSub != null) this.statsGetDropdownContentsForKindSub.unsubscribe();
    if (this.statsGetAutocompleteListSub != null) this.statsGetAutocompleteListSub.unsubscribe();
    if (this.valueChangesSub != null) this.valueChangesSub.unsubscribe();
  }

  getErrors(errors: ValidationErrors) {
    let errs: string[] = [];

    if (errors == null)
      return errs;

    let keys = Object.keys(errors);

    if (keys.includes('required'))
      errs.push(this.translate.instant('stats.graphs.filters.errors.required'));

    let hasMax: boolean = keys.includes('max');
    let hasMin: boolean = keys.includes('min');

    let isNumUpDown: boolean = (this.filterProps.type == FilterType.NUMUPDOWN);
    let isTextBox: boolean = ((this.filterProps.type == FilterType.TEXTBOX) || (this.filterProps.type == FilterType.TEXTBOXADVANCED));

    if (isNumUpDown || isTextBox) {
      if (hasMax || hasMin) {
        if (this.filterProps.min != null && this.filterProps.max != null)
          errs.push(this.translate.instant('stats.graphs.filters.errors.minmax' + (isTextBox ? 'L' : ''), { min: this.filterProps.min, max: this.filterProps.max }));
        else if (hasMin)
          errs.push(this.translate.instant('stats.graphs.filters.errors.min' + (isTextBox ? 'L' : ''), { min: this.filterProps.min }));
        else if (hasMax)
          errs.push(this.translate.instant('stats.graphs.filters.errors.max' + (isTextBox ? 'L' : ''), { max: this.filterProps.max }));
      }
    }

    return errs;
  }

  getAutocompleteList(minLen: number = 2, sendPrevious: boolean = false, bypassCheck: boolean = false) {
    let isWithExt = (this.filterProps.kind == StatsGraphFilterKind.CWTCOLORCODE || this.filterProps.kind == StatsGraphFilterKind.CWTDESIG);
    let isWithoutExt = (this.filterProps.kind == StatsGraphFilterKind.CWTMANUFACTURER);

    if (!isWithExt && !isWithoutExt && !bypassCheck)
      return;

    let text: string = (sendPrevious ? this.previousValue : this.formGroup.controls[StatsGraphFilterKind[this.filterProps.kind]].value) ?? "";
    
    let extension: number = isWithExt ? this.formGroup.controls[StatsGraphFilterKind[this.filterProps.kind] + "-EXT"].value : 0;

    if (text.length >= minLen) {
      this.statsGetAutocompleteListSub = this.apiService.statsGetAutocompleteList(this.filterProps.kind, text, extension).subscribe(data => {
        this.autocompleteList = data;
        if (this.statsGetAutocompleteListSub != null) this.statsGetAutocompleteListSub.unsubscribe();
      },
      error => {
        if (this.statsGetAutocompleteListSub != null) this.statsGetAutocompleteListSub.unsubscribe();
      });
    }
  }
}
